import { Link } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#080C14] px-6" data-testid="payment-cancel-page">
      <div className="w-full max-w-md rounded-3xl border border-cyan-500/20 bg-[#0E1524]/80 p-10 text-center backdrop-blur-xl">
        <XCircle size={40} className="mx-auto text-slate-500" />
        <h1 className="font-display mt-5 text-2xl font-extrabold text-slate-50">Paiement annulé</h1>
        <p className="mt-3 text-sm leading-relaxed text-slate-400">
          Aucun montant n'a été débité. Vous pouvez reprendre le paiement de votre acompte quand
          vous le souhaitez — votre demande reste intacte.
        </p>
        <Link
          to="/"
          data-testid="payment-cancel-back"
          className="mt-8 inline-flex items-center gap-2 rounded-full border border-cyan-400/30 px-6 py-3 text-sm font-semibold text-cyan-300 transition-colors hover:border-cyan-400/60 hover:bg-cyan-400/10"
        >
          <ArrowLeft size={15} /> Retour au site
        </Link>
      </div>
    </div>
  );
}
